import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["programsPanel", "schedulesPanel", "programsHint", "schedulesHint"];

  connect() {
    this.togglePanels();
  }

  change(event) {
    this.clearSelectionsForMode();
    this.togglePanels();
  }

  toggle(event) {
    this.clearSelectionsForMode();
    this.togglePanels();
  }

  togglePanels() {
    const selected = this.element.querySelector('input[name*="access_kind"]:checked')?.value || "all";

    if (this.hasProgramsPanelTarget) {
      this.programsPanelTarget.classList.toggle("hidden", selected !== "programs");
    }
    if (this.hasSchedulesPanelTarget) {
      this.schedulesPanelTarget.classList.toggle("hidden", selected !== "schedules");
    }
  }

  clearSelectionsForMode() {
    const selected = this.element.querySelector('input[name*="access_kind"]:checked')?.value || "all";

    const programCheckboxes = this.element.querySelectorAll('input[name*="program_ids"]');
    const scheduleCheckboxes = this.element.querySelectorAll('input[name*="timeslot_schedule_ids"]');

    programCheckboxes.forEach((cb) => { cb.checked = false; });
    scheduleCheckboxes.forEach((cb) => { cb.checked = false; });

    if (selected === "programs") this.showHint("programs");
    else if (selected === "schedules") this.showHint("schedules");

    this.element.dispatchEvent(new CustomEvent("plan-access:selectionsCleared", { bubbles: true }));
  }

  showHint(mode) {
    const hint = mode === "programs" ? this.programsHintTarget : this.schedulesHintTarget;
    if (!hint) return;
    hint.classList.remove("hidden");
    clearTimeout(this._hintTimeout);
    this._hintTimeout = setTimeout(() => hint.classList.add("hidden"), 3000);
  }
}
